import { isApiError } from '@servicedesk/ui';
import { Alert, Box, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRaiseTicket } from '../api/hooks';

const PRIORITIES = ['Low', 'Medium', 'High', 'Urgent'];

export function NewTicketPage() {
  const navigate = useNavigate();
  const raise = useRaiseTicket();
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState('Medium');
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setError(null);
    try {
      const detail = await raise.mutateAsync({
        subject,
        description,
        priorityName: priority,
        source: 'portal',
      });
      navigate(`/tickets/${detail.id}`);
    } catch (e) {
      setError(isApiError(e) ? e.message : 'Could not raise your ticket');
    }
  }

  return (
    <Box>
      <Typography variant="h1" sx={{ mb: 2 }}>
        Raise a ticket
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="What do you need help with?"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
          <TextField
            label="Tell us more"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            minRows={5}
            required
          />
          <TextField
            label="How urgent is it?"
            select
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          >
            {PRIORITIES.map((p) => (
              <MenuItem key={p} value={p}>
                {p}
              </MenuItem>
            ))}
          </TextField>
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={() => navigate('/tickets')}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => void submit()}
              disabled={raise.isPending || !subject || !description}
            >
              Submit
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
